import Svg, { Path } from 'react-native-svg'

const HeaderArrowLeft = ({ width = 24, height = 24, color = '#fff' }: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <Path
      fill={color}
      d="m2.29 12.71 6 6a1.004 1.004 0 1 0 1.42-1.42L5.41 13H21a1 1 0 1 0 0-2H5.41l4.3-4.29a1 1 0 0 0 0-1.42 1 1 0 0 0-1.42 0l-6 6a1 1 0 0 0 0 1.42Z"
    />
  </Svg>
)
export default HeaderArrowLeft
